<template>
  <aside class="tree-navigator"
         :class="{'tree-navigator_closed': !isOpen, 'tree-navigator_sidebar': !sidebarOpen}">
    <div class="scroll-content">
      <header class="navigator-top">
        <router-link tag="h2"
                     to="/projects"
                     v-if="isOpen"
                     class="title title-big">
          {{$t('things.navigator')}}
        </router-link>
        <button type="button" @click="toggleNavigator">
          <navigator-icon :active="isOpen"></navigator-icon>
        </button>
      </header>
      <vue-tree-list :default-expanded="false"
                     v-if="isOpen"
                     @click="clickInNode"
                     class="nav-body"
                     :model="tree">
        <span class="icon icon-single" slot="leafNodeIcon">
          <leaf-icon></leaf-icon>
        </span>
        <span class="icon icon-group" slot="treeNodeIcon">
          <group-icon></group-icon>
        </span>
        <span class="icon icon-mother" slot="delNodeIcon">
          <mother-icon></mother-icon>
        </span>
      </vue-tree-list>
      <router-link tag="h2" to="/projects" class="title title-big title_opacity" v-else>
        {{$t('things.navigator')}}
      </router-link>
    </div>
  </aside>
</template>

<script>
  import navigatorIcon from '../../Svg/things/navigatorIcon'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import {VueTreeList, Tree, TreeNods} from 'vue-tree-list'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {sidebarState} from "../../../mixins/utils/sidebarState";
  import groupIcon from '../../Svg/projects/navigator/groupIcon'
  import leafIcon from '../../Svg/projects/navigator/leafIcon'
  import motherIcon from '../../Svg/projects/navigator/motherIcon'
  import {navigatorMixin} from "../../../mixins/utils/navigatorMixin";

  export default {
    name: 'projectsNavigator',
    props: {
      projectEdit: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    mixins: [tokenAndRoute, sidebarState, navigatorMixin],
    components: {
      navigatorIcon,
      VueTreeList,
      groupIcon,
      leafIcon,
      motherIcon
    },
    computed: {
      ...mapState({
        isOpen: state => state.openProjectsNavigator,
        project: state => state.projects.singleProject
      }),
      ...mapGetters({
        treeNavigator: 'projects/navigatorTree',
        projectTree: 'projects/projectsTree'
      }),
      tree() {
        return new Tree([this.treeNavigator])
      }
    },
    watch: {
      projectTree(val) {
        this.setActiveNode(val.name)
      }
    },
    methods: {
      ...mapMutations({
        setIsOpen: 'TOGGLE_OPEN_PROJECTS_NAVIGATOR',
        setDirName: 'projects/SET_DIR_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      }),

      toggleNavigator() {
        this.setIsOpen(!this.isOpen);
      },
      clickInNode(node) {

        this.setDirName(node.name)

        let projectId
        let treeItem

        let findParent = (item) => {
          treeItem = item.parent
          if (item.parent.id !== 0) {
            projectId = item.parent.id
            findParent(treeItem)
          }
        }

        findParent(node)

        this.setRouteName(node.name);

        if (this.projectEdit) {

          if (node.isMother) {
            this.$router.push(`/project-edit/${node.id}`)
          } else {
            this.$router.push(`/project-edit/${projectId}/project-item/${node.id}`)
          }

        } else if (node.isMother) {
          this.$router.push(`/project/${node.id}`)
        } else {
          this.$router.push(`/project/${projectId}/project-item/${node.id}`)
        }
      },
    },
    mounted() {
      if (this.routeId || this.routeItem) {
        this.setActiveNode(this.projectTree.name)
      };
    }
  }
</script>

<style lang="scss" scoped>
.zoomed-navigator {
  top: 0;
  left: 0;
}
</style>
